import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

import { PaymentIntentSummaryDTO } from "../../../../models/EnrollmentHistoryDTO";

/*
	Tickets que mandó el alumno desde "Reporta tu pago" (/pagar, 2026-10-10). Pueden no estar ligados a
	un alumno de WAPP (el teléfono no dio con uno solo del plantel): entonces se ve lo que escribió y
	Caja busca a quién aplicarlo.
*/
export const EtiquetaAlumno: React.FC = () => (
	<span style={{ display: "inline-block", padding: "0 8px", borderRadius: 999, background: "transparent", color: "var(--wa-oro)", border: "1px solid var(--wa-oro)",
		fontSize: 12, fontWeight: 600, whiteSpace: "nowrap", verticalAlign: 1 }}>Lo envió el alumno</span>
);

/** Solicitud de Promoción (ESPEC_SOLICITUD_PROMO, 2026-10-31): la asesora pidió la promo con su comprobante; Caja la aplica en Registrar Pago. */
export const EtiquetaPromo: React.FC = () => (
	<span style={{ display: "inline-block", padding: "0 8px", borderRadius: 999, background: "var(--wa-acento-suave)", color: "var(--wa-acento-texto)", border: "1px solid var(--wa-acento)",
		fontSize: 12, fontWeight: 600, whiteSpace: "nowrap", verticalAlign: 1 }}>Solicitud de Promoción</span>
);

export const nombreDelTicket = (r: PaymentIntentSummaryDTO): string => r.studentName || r.contactName || "-";

/** Debajo del nombre: el correlativo, o "Sin alumno en WAPP" si no se encontró. */
export const SubNombre: React.FC<{ r: PaymentIntentSummaryDTO }> = ({ r }) => r.studentId
	? <div style={{ fontSize: 13, color: "var(--wa-apagado)" }}>{r.identityCode || "-"}</div>
	: <div style={{ fontSize: 13, color: "var(--wa-oro)" }}>Sin alumno en WAPP</div>;

/** Matrícula grupal y depósitos a medias, debajo del nombre en Pagos por Procesar (2026-10-27). */
export const GrupoYFotos: React.FC<{ r: PaymentIntentSummaryDTO }> = ({ r }) => (
	<>
		{(r.groupNames || []).length > 0 ? (
			<div style={{ fontSize: 13, marginTop: 4, lineHeight: 1.35, color: "var(--wa-apagado)", display: "flex", gap: 6, alignItems: "baseline" }} title="Van juntas: un solo ticket">
				<FontAwesomeIcon icon={solid("users")} style={{ color: "var(--wa-acento-texto)", flex: "0 0 auto" }} /><span>{(r.groupNames || []).join(", ")}</span>
			</div>
		) : null}
		{(r.photosRegistered || 0) > 0 && (r.photosRegistered || 0) < (r.photosTotal || 0)
			? <div style={{ fontSize: 13, color: "var(--wa-oro)", fontWeight: 600, marginTop: 2 }}>{r.photosRegistered} de {r.photosTotal} fotos registradas</div> : null}
	</>
);

/** Lo que el alumno escribió: teléfono (con lada, solo dígitos, como Woztell), correo y país, en una línea. */
export const contactoDelAlumno = (r: PaymentIntentSummaryDTO): string =>
	[r.contactPhone, r.contactEmail, r.contactCountry].filter((x) => x && String(x).trim() !== "").join(" · ");
